import { ITechnicalCategoryBookmarkHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

interface IProps {
  orderId: string;
  maxResultCount?: number;
}

export const useTechnicalCategoryBookmarks = ({
  orderId,
  maxResultCount = 100,
}: IProps): ITechnicalCategoryBookmarkHook => {
  const { technicalCategoryStore } = useStore();
  const { pagedBookmarks } = technicalCategoryStore;

  useEffect(() => {
    orderId &&
      technicalCategoryStore.getAllBookmarks({
        orderId,
        maxResultCount,
        skipCount: 0,
      });
    return () => {
      technicalCategoryStore.clearPagedBookmarks();
    };
  }, [technicalCategoryStore, maxResultCount, orderId]);

  return {
    bookmarks: pagedBookmarks.items,
    totalCount: pagedBookmarks.totalCount,
  };
};
